module.exports = __webpack_public_path__ + "assets/img/shanghu.e5aa80be.svg";